<template>
  <settings-wrapper>
    <div custom-tab>
      <p class="mt-5 font-weight-medium"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.changePassword.client')}} {{userSettings.name}}!</p>
      <p :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">{{$t('pages.changePassword.info')}}</p>
      <v-form ref="changeLogin">
                <v-row>
        <v-col cols="12" sm="4">
          <p class="font-weight-medium pt-1" 
            :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.changePassword.currentLogin')}}:</p>
        </v-col>

        <v-col cols="12" sm="6">
          <span v-if="!edit" class="font-weight-medium d-block pt-2">{{userSettings.login}}</span>
        </v-col>
      </v-row>
           <v-row>
        <v-col cols="12" sm="4">
          <p class="font-weight-medium pt-1" 
              :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.changePassword.newLogin')}}:</p>
        </v-col>

        <v-col cols="12" sm="5" class="pb-0">
          <v-text-field
            class="custom-text-field helvetica-roman fs-16"
            v-model="newLogin"
            :disabled="loading"
            single-line
            outlined
            :rules="loginRules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="mt-0">
          <v-col cols="12" sm="4" class="text-center text-sm-left">
          </v-col>
          <v-col cols="12"  :sm="currentLocale === 'ru' ? 1 : 2" class="text-center text-sm-left">
            <v-btn @click="clearInputLogin" class=" outlined-transparent-button" outlined>{{$t('buttons.cancel')}}</v-btn>
          </v-col>
          <v-col cols="12"  sm="1"  class="text-center text-sm-left ml-sm-12">
            <v-btn class="green-button" @click="saveChanges" :loading="loading" dark>{{$t('buttons.save')}}</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-form ref="form">

        <v-row>
          <v-col cols="12" sm="4" class="pb-0">
            <p class="font-weight-medium pt-1"
                :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.changePassword.currentPassword')}}:</p>
          </v-col>

          <v-col cols="12" sm="5" class="pb-0">
            <v-text-field
              class="custom-text-field helvetica-roman fs-16"
              v-model="oldPassword"
              @click:append="show.oldPassword = !show.oldPassword"
              :append-icon="show.oldPassword? 'mdi-eye-off' : 'mdi-eye'"
              :type="show.oldPassword ? 'text' : 'password'"
              :disabled="loading"
              single-line
              outlined
              :rules="passwordRules"
              key="s"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="pb-0">
            <p class="font-weight-medium pt-1"
                :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.changePassword.newPassword')}}:</p>
          </v-col>
          <v-col cols="12" sm="5" class="pb-0">
            <v-text-field
              class="custom-text-field helvetica-roman fs-16"
              v-model="newPassword"
              @click:append="show.newPassword =! show.newPassword"
              :append-icon="show.newPassword? 'mdi-eye-off' : 'mdi-eye'"
              :type="show.newPassword ? 'text' : 'password'"
              :disabled="loading"
              single-line
              outlined
              :rules="passwordRules"
              key="q"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="4" class="pb-0">
            <p class="font-weight-medium pt-1"
                :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">{{$t('pages.changePassword.confirmNewPassword')}}:</p>
          </v-col>

          <v-col cols="12" sm="5" class="pb-0">
            <v-text-field
              class="custom-text-field helvetica-roman fs-16"
              v-model="newPasswordConfirm"
              @click:append="show.newPasswordConfirm =! show.newPasswordConfirm"
              :append-icon="show.newPasswordConfirm? 'mdi-eye-off' : 'mdi-eye'"
              :type="show.newPasswordConfirm ? 'text' : 'password'"
              :disabled="loading"
              single-line
              outlined
              :rules="newPasswordConfirm !== newPassword ? passwordRepeat : passwordRules"
              key="w"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row class="mt-0">
          <v-col cols="12" sm="4" class="text-center text-sm-left">
          </v-col>
          <v-col cols="12" :sm="currentLocale === 'ru' ? 1 : 2" class="text-center text-sm-left">
            <v-btn @click="clearInputs" class=" outlined-transparent-button" outlined>{{$t('buttons.cancel')}}</v-btn>
          </v-col>
          <v-col cols="12" sm="1" class="text-center text-sm-left  ml-sm-12">
            <v-btn class="green-button" @click="saveNewPassword" :loading="loading" dark>{{$t('buttons.save')}}</v-btn>
          </v-col>
          <modal-change-login v-model="showChangeLogin" :newLogin="newLogin" @change="singOut"/>
        </v-row>
      </v-form>
    </div>
  </settings-wrapper>
</template>
<script>
import SettingsWrapper from "@/components/settings/wrappers/index.vue";
import ModalChangeLogin from  "../../../components/modals/ModalChangeLogin";
import { mapGetters } from "vuex";

export default {
  layout: "main",
  components: { SettingsWrapper, ModalChangeLogin },
  name: "TabItemChangePassword",

  props: {
    value: String
  },

  data: () => ({
    show: {
      oldPassword: false,
      newPassword: false,
      newPasswordConfirm: false
    },
    oldPassword: "",
    newPassword: "",
    newLogin: "",
    newPasswordConfirm: "",
    loading: false,
    showChangeLogin: false,
  }),

  computed: {
    ...mapGetters("locale",["currentLocale"]),

    userSettings() {
      return { ...this.$store.getters["account/userSettings"] };
    },
    showCancelBtn() {
      return (
        !!this.oldPassword || !!this.newPassword || !!this.newPasswordConfirm
      );
    },
    passwordRules(){  
      return [
      v => !!v || this.$t('rules.inputPassword'),
      v => /^[^'"\|`~{}\[\]\/()\\=.,<>\s\t]+$/.test(v) || this.$t('rules.badSymbols')
    ]
    },
    loginRules(){
      return  [
      v => !!v || this.$t('rules.inputLogin'),
      v => /^[a-zA-Zа-яА-ЯёЁ0-9-_]+$/.test(v) || this.$t('rules.badSymbols')
    ]
    },
    passwordRepeat(){ return [v => this.$t('rules.passwordsDontMatch')]},
  },

  methods: {
    validate() {
      return !!this.$refs.form.validate();
    },
    validateLogin(){
        return !!this.$refs.changeLogin.validate();
    },

    saveChanges() {

      if(this.validateLogin()){
        this.loading = true;
        let payload ={
          newLogin: this.newLogin
        };
      this.$store.dispatch("account/changeLogin", payload).then((response) => {
        if(response.data.success){
          this.showChangeLogin = true;
        }
                this.loading = false;
          // this.$router.push("/authorization");
        });
          }
    },
    saveNewPassword(){
      if (this.validate()) {
        this.loading = true;
        let payload = {
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        };
        this.$store.dispatch("account/changePassword", payload).then(() => {
          this.loading = false;
        });
      }
    },

    clearInputLogin() {
      this.$refs.changeLogin.reset();
    },

    clearInputs() {
      this.$refs.form.reset();
    }, 
    singOut(){
      this.$store.dispatch("account/logOut");
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-text-field {
  .v-input__slot {
    min-height: 20px !important;
  }
}
</style>
